<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 17H3a1 1 0 01-.92-.62 1 1 0 01.21-1.09l9-9a1 1 0 011.42 0l9 9a1 1 0 01.21 1.09A1 1 0 0121 17zM5.41 15h13.18L12 8.41z"/></svg>